import { loadApp } from "src/loadApp";

loadApp(() => import("./app"));
